module.exports = __webpack_public_path__ + "img/club_card_bg2.2a4606be.png";